export function humanReadAbleChargingTime(displayValue: number): string {
  const time = timeConvert(displayValue);
  return `${time.hours}:${time.minutes}`;
}

export function timeConvert(num: number): { hours: string; minutes: string } {
  if (num <= 0) {
    return {
      hours: '0',
      minutes: '00',
    };
  }
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.floor(minutes);
  return {
    hours: `${rhours}`,
    minutes: rminutes < 10 ? `0${rminutes}` : `${rminutes}`,
  };
}
